import { Auth } from 'aws-amplify'

export const cognitoSignUp = async (username, password) => {
  let result = {
    isError: false,
  }

  try {
    result.data = await Auth.signUp(username, password)
  } catch (error) {
    result.isError = true
    result.data = error
  }

  return result
}
